import { render, staticRenderFns } from "./Action_modal.vue?vue&type=template&id=584dabce&scoped=true&"
import script from "./Action_modal.vue?vue&type=script&lang=js&"
export * from "./Action_modal.vue?vue&type=script&lang=js&"
import style0 from "./Action_modal.vue?vue&type=style&index=0&id=584dabce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584dabce",
  null
  
)

export default component.exports